import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { Province, ProvinceDataService } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";

export interface ProvinceOptions extends ControllerOptions<Province> {}

export const initProvince = (): Province => createProvince({});

export const createProvince = (item: Partial<Province>): Province => ({
    id: item.id ?? "",
    name: item.name ?? "",
    abbreviation: item.abbreviation ?? "",
    createdBy: item.createdBy ?? ""
});

export class ClientProvinceService extends BaseClientService implements DataController<Province> {
    private _service: ProvinceDataService;

    constructor() {
        super();
        this._service = new ProvinceDataService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }

    public async get(options: ProvinceOptions): Promise<ResultData<Province>> {
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);
    }

    public async getLookup(options: ProvinceOptions): Promise<ResultData<Province>> {
        return await this._service.get(this.buildLookupFetchParams(options), this.token, options.filter);
    }

    public async getById(options: ProvinceOptions): Promise<Province | null> {
        return options.id ? await this._service.getById(options.id, this.token) : null;
    }

    public async delete(options: ProvinceOptions): Promise<void> {
        if (options.id) await this._service.delete(options.id, this.token);
    }

    public async update(options: ProvinceOptions): Promise<Province | Province[] | null> {
        return options.item?.id
            ? await this._service.update(options.item.id, options.item, this.token)
            : null;
    }

    public async add(options: ProvinceOptions): Promise<Province | Province[] | null> {
        return options.item ? await this._service.add(options.item, this.token) : null;
    }

    public async import(options: ProvinceOptions): Promise<any> {
        if (options.file) return await this._service.import(this.token, options.file);
        return null;
    }

    public async export(options: ProvinceOptions): Promise<any> {
        return await this._service.export(this.token, options.filter);
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult | null> {
        return await this._service.validateName(name, this.token, id, "");
    }
}
